import React from 'react';

export default function CheckCircleOverlay({ size = 32, color = '#28a745', style = {} }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" style={{ position: 'absolute', right: 0, top: 0, ...style }}>
      <circle cx="16" cy="16" r="16" fill={color} opacity="0.9" />
      <polyline points="10,17 15,22 23,12" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
